import Speaker1 from '../../assets/img/success/speakers/1.png'
import Speaker2 from '../../assets/img/success/speakers/2.png'
import Speaker3 from '../../assets/img/success/speakers/3.png'
import Speaker4 from '../../assets/img/success/speakers/4.png'
import Speaker5 from '../../assets/img/success/speakers/5.png'
import Speaker6 from '../../assets/img/success/speakers/6.png'
import Speaker7 from '../../assets/img/success/speakers/7.png'
import Speaker8 from '../../assets/img/success/speakers/8.png'
import Gallery from "react-grid-gallery";

const images = [
    {
        src: Speaker1,
        thumbnail: Speaker1,
        thumbnailWidth: 340,
        thumbnailHeight: 340,
    },
    {
        src: Speaker2,
        thumbnail: Speaker2,
        thumbnailWidth: 340,
        thumbnailHeight: 340,
    },
    {
        src: Speaker3,
        thumbnail: Speaker3,
        thumbnailWidth: 340,
        thumbnailHeight: 340,
    },
    {
        src: Speaker4,
        thumbnail: Speaker4,
        thumbnailWidth: 340,
        thumbnailHeight: 340,
    },
    {
        src: Speaker5,
        thumbnail: Speaker5,
        thumbnailWidth: 340,
        thumbnailHeight: 340,
    },
    {
        src: Speaker6,
        thumbnail: Speaker6,
        thumbnailWidth: 340,
        thumbnailHeight: 340,
    },
    {
        src: Speaker7,
        thumbnail: Speaker7,
        thumbnailWidth: 340,
        thumbnailHeight: 340,
    },
     {
        src: Speaker8,
        thumbnail: Speaker8,
        thumbnailWidth: 340,
        thumbnailHeight: 340,
    }
]

const SuccessSpeakersOne = () => {
    return (
        <div className='success_conference'>
            <section>
                <h3>Prelegenci konferencji inaugurującej projekt w roku szkolnym 2025/2026</h3>
                <div className='speakers'>
                    <Gallery images={images} margin={0} enableImageSelection={false} />
                </div>
            </section>
        </div>
    );
};

export default SuccessSpeakersOne;